var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.52637 0.417982C8.82095 0.177673 9.25567 0.195136 9.53027 0.46974L13 3.93947L16.4697 0.46974C16.6842 0.255261 17.0069 0.190612 17.2871 0.306654C17.5674 0.42274 17.75 0.696667 17.75 1.00001V10C17.75 10.4142 17.4142 10.75 17 10.75H1C0.585786 10.75 0.25 10.4142 0.25 10V1.00001C0.25 0.696667 0.432635 0.42274 0.712891 0.306654C0.993129 0.190612 1.31579 0.255261 1.53027 0.46974L5 3.93947L8.46973 0.46974L8.52637 0.417982ZM5.53027 5.53029C5.23738 5.82318 4.76262 5.82318 4.46973 5.53029L1.75 2.81056V9.25001H16.25V2.81056L13.5303 5.53029C13.2374 5.82318 12.7626 5.82318 12.4697 5.53029L9 2.06056L5.53027 5.53029Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/Icon4.66294f8a04b204a5066d0156880090f9.svg";
export { ForwardRef as ReactComponent };